import { getApiUrl } from '../config/api';
import authFetch from './authFetch';

/**
 * Switch the caller's active organization.
 *
 * Calls POST /api/v1/auth/switch-org and persists the returned tokens to
 * localStorage under the same keys the login flow uses, so the new org context
 * survives a reload. Returns the response payload.
 *
 * Throws on a non-OK response; callers decide how to reload/navigate afterwards
 * (a full reload/navigation is the accepted way to refetch org-scoped data).
 */
export default async function switchOrganization(organizationId) {
  const response = await authFetch(getApiUrl('/api/v1/auth/switch-org'), {
    method: 'POST',
    body: JSON.stringify({ organization_id: organizationId }),
  });

  if (!response.ok) {
    throw new Error(`Switch failed: ${response.status}`);
  }

  const data = await response.json();
  localStorage.setItem('access_token', data.access_token);
  localStorage.setItem('refresh_token', data.refresh_token);
  if (data.first_name) {
    localStorage.setItem('first_name', data.first_name);
  }
  return data;
}
